export const LOCAL_STORAGE_KEYS = {
  ID: 'id',
  NAME: 'name',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  EMAIL: 'email',
  PHONE: 'phone',
  USER_ID: 'user_id',
  COUNTRY: 'country',
  TOKEN: 'token',
  REFRESH_TOKEN: 'refresh_token',
  TOKEN_EXPIRY: 'token_expiry',
  COMPANY_NAME: 'company_name',
  LOGO_URL: 'logo_url',
  LANGUAGE: 'language',
  IS_LIVE: 'is_live',
  ANNOUNCEMENT_BAR_SEEN: 'announcement_bar_seen',
  XPENCE: 'xpence',
  MERCHANT_ID: 'merchant_id',
  FLASH_REDIRECT: 'flash_redirect',
  PERMISSIONS: 'permissions',
  NO_BANK: 'no_bank',
  PROFILE_TYPE: 'profile_type',
  MERCHANT_ROLE: 'merchant_role',
  FILLED_BUSINESS_DATA: 'filled_business_data',
  PAYOUT_ENABLED: 'payout_enabled',
  PAYOUT_TERMS: 'payout_terms',
  FILLED_ANSWER: 'filled_answer',
  IS_BILLS_NEW: 'is_bills_new',
  PROFILE_TOKEN: 'profile_token',
  TEMP_TOKEN: 'temp_token',
  SIGNUP_BY_PHONE_TOKEN: 'signup_by_phone_token',
  MERCHANT_STATEMENTS: 'merchant_statements',
  DIGEST: 'digest',
  DEEP_LINK: 'deep_link',
  INSTANT_SETTLEMENT_ENABLED: 'instant_settlement_enabled',
  SHOW_DASHBOARD_TOUR: 'show_new_dashboard_tour',
  LIVE_ONBOARDING_BANNER_SEEN: 'onboarding_banner_live_seen',
  BILLS_ENABLED: 'bills_enabled',
  BALANCE_AND_TRANSFERS_LAST_ACTION: 'last_balance_and_transfers_action',
  IS_DISTRIBUTOR: 'is_distributor',
  AMPLITUDE_USER_ID_TRACKED: 'amplitude_user_id_tracked',
  IS_PAYMOB_PRO_ENABLED: 'is_paymob_pro_enabled',
  OPEN_PAYMOB_PRO_DRAWER: 'open_paymob_pro_drawer',
  PAYMOB_PLAN: 'paymob_pro_plan',
  PAYMOB_PRO_END_DATE: 'paymob_pro_end_date'
};
